import { render } from "./TeacherClassesSelectPopup.vue?vue&type=template&id=3cf4ca5e&scoped=true&ts=true"
import script from "./TeacherClassesSelectPopup.vue?vue&type=script&lang=ts"
export * from "./TeacherClassesSelectPopup.vue?vue&type=script&lang=ts"

import "./TeacherClassesSelectPopup.vue?vue&type=style&index=0&id=3cf4ca5e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf4ca5e"]])

export default __exports__